import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyWelcomePagePasswordGate = loadable(
  () => import(/* webpackChunkName: "content/guest/welcome-password-gate" */ './WelcomePagePasswordGate'),
  'WelcomePagePasswordGate',
);
